export function buildCommonContext() {
    return {
        view: {
            referrer: document.referrer,
            url: window.location.href,
        },
    };
}
//# sourceMappingURL=commonContext.js.map